import LegacyPublicationPageRecord from "models/view-models/legacy-publication-page-record";
import { atom, useAtom } from "jotai";

export const currentPageNumberAtom = atom<number>(1);

export const currentPageAtom = atom<LegacyPublicationPageRecord | undefined>();

export function usePdfPublicationPageState() {
    const [currentPageNumber, setCurrentPageNumber] = useAtom(
        currentPageNumberAtom
    );

    return {
        currentPageNumber,
        setCurrentPageNumber,
    };
}
